export { AppearanceChannel } from "./appearance_channel";
import { NotificationsChannel } from "./notifications_channel";

export const notificationsChannel = NotificationsChannel({
  onConnected: () => {
    console.log("Connected to NotificationsChannel");
  },
  onDisconnected: () => {
    console.log("Disconnected from NotificationsChannel");
  },
  onRejected: () => {
    console.log("Rejected on NotificationsChannel");
  },
  onReceived: (data) => {
    console.log("NotificationsChannel data: ", data);
  },
});

// setTimeout(function () {
//   notificationsChannel.send({ body: "This is a cool chat app." });
// }, 5000);
